export default __webpack_public_path__ + "static/media/mandrill-negative.f3679b98.svg";